import styled from '@emotion/styled';
import { ITheme, Responsive, RowRole } from '../../../ui';
import * as PolicyNumber from './columns/PolicyNumber';
import * as PolicyName from './columns/PolicyName';
import * as PolicyDescription from './columns/PolicyDescription';
import * as PolicyDownload from './columns/PolicyDownload';
import { Color } from '../../../styles/Color';

const StyledRow = styled(RowRole)<{}, ITheme>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-top: 1px solid ${Color.BorderCard};

	font-size: ${({ theme }) => theme.typography?.small?.size};
	font-weight: 400;
	color: ${({ theme }) => theme.color?.text?.light};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;

export function PolicyListHeader({ className }: { className?: string }) {
	return (
		<StyledRow className={className}>
			<PolicyNumber.Header />
			<PolicyName.Header />
			<PolicyDescription.Header />
			<PolicyDownload.Header />
		</StyledRow>
	);
}
